<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
}
</script>

<style>
:root {
  --primary-color: #0066ff;
  --primary-gradient: linear-gradient(135deg, #0066ff 0%, #00a0ff 100%);
  --secondary-color: #00d4aa;
  --bg-gradient: linear-gradient(180deg, #0a1628 0%, #1a2a4a 50%, #0d1f3c 100%);
  --card-bg: rgba(255, 255, 255, 0.08);
  --card-border: rgba(255, 255, 255, 0.12);
  --text-primary: #ffffff;
  --text-secondary: rgba(255, 255, 255, 0.7);
  --text-muted: rgba(255, 255, 255, 0.5);
  --input-bg: rgba(255, 255, 255, 0.1);
  --input-border: rgba(255, 255, 255, 0.2);
  --border-radius: 12px;
  --border-radius-lg: 16px;
  --btn-radius: 25px;
}

* {
  box-sizing: border-box;
}

html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  color: var(--text-primary);
  background: var(--bg-gradient);
}

::-webkit-scrollbar {
  display: none;
}
</style>
